import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dialog-input-title',
  templateUrl: './dialog-input-title.component.html',
  styleUrls: ['./dialog-input-title.component.css'],
})
export class dialogInputTitleComponent {
  @Input() title!: string; // Title text
  @Input() required?: boolean = false; // Boolean to determine if required
  @Input() value?: any; // Variable to determine if required dynamically

  get isRequired(): boolean {
    return (
      this.required ??
      (this.value === null || this.value === undefined || this.value === '')
    );
  }
}
